<template>
    <div class="small">
        <div v-for="(comment, index) in comments" :key="index" :id="'comment' + comment.id" class="mb-2">
            <div class="small">
                <a href="#" class="float-right text-danger px-1" @click="destroy(comment)">
                    <i class="fas fa-times" v-if="deleting != comment.id"></i>
                    <i class="fas fa-spinner fa-spin" v-if="deleting == comment.id"></i>
                </a>
                {{ comment.commentator.name }}
            </div>
            <pre class="alert alert-primary small mb-0 p-2">{{ comment.text }}</pre>
            <div class="small text-right">{{ comment.time }}</div>
        </div>
        <div v-if="comments.length == 0">
            <div class="text-muted text-center p-3">コメントがありません</div>
        </div>
        <b-form-group class="mb-1">
            <b-form-textarea v-model="newComment"></b-form-textarea>
        </b-form-group>
        <div class="text-right">
            <b-button @click="save" :disabled="cantSave" variant="primary" size="sm">
                <i class="fas fa-spinner fa-spin" v-if="saving"></i>
                送信
            </b-button>
        </div>
    </div>
</template>
<script>
export default {
    props: ["nippou_id"],
    data() {
        return {
            comments: [],
            newComment: "",
            user: {},
            saving: false,
            deleting: null
        }
    },
    mounted() {
        this.user = window.authUser
        this.load()
    },
    computed: {
        cantSave() {
            return this.saving || !this.newComment
        }
    },
    methods: {
        load() {
            let url = `/api/comment/?model_type=App\\Nippou&model_id=${this.nippou_id}`
            axios.get(url).then((response) => {
                console.log("load comments", response.data)
                this.comments = response.data.comments
            })
        },
        save() {
            if (this.saving || !this.newComment) return
            this.saving = true

            let url = `/api/comment`
            let data = {
                id: this.nippou_id,
                model: "App\\Nippou",
                text: this.newComment,
                user_id: this.user.id
            }
            axios
                .post(url, data)
                .then((response) => {
                    this.load()
                })
                .catch((error) => {
                    console.log("error", error.response.data)
                })
                .finally(() => {
                    this.newComment = ""
                    this.saving = false
                })
        },
        destroy(comment) {
            if (this.deleting) return
            let result = confirm("コメントを削除しますか？")
            if (!result) return

            this.deleting = comment.id

            let url = `/api/comment/${comment.id}`
            axios
                .delete(url)
                .then((response) => {
                    this.load()
                })
                .catch((error) => {
                    console.log("error", error.response.data)
                })
                .finally(() => {
                    this.deleting = null
                })
        }
    }
}
</script>